<script setup>
import FooterBlank from "@/layouts/components/FooterBlank.vue"
import { router } from "@/plugins/1.router"
import { dataLegals } from "@/utils/content"
definePage({
  meta: {
    layout: "new-home",
    public: true,
  },
})
const CURRENT_YEAR = import.meta.env.VITE_CURRENT_YEAR

function redirectHome() {
  router.push({ name: "index" })
}
</script>

<template>
  <div class="register">
    <section
      id="login"
      class="hero mb-4"
    >
      <div class="hero__overlay">
        <div class="home-page__container hero__content">
          <h1>Eduniversal Programs<br class="d-md-none d-block"> Survey {{ +CURRENT_YEAR }}</h1>
          <h2>
            {{ +CURRENT_YEAR + 1 }} Eduniversal Ranking of the <br class="d-md-none d-block"> Best Masters, MBA & DBA <br>
          </h2>
        </div>
      </div>
    </section>

    <div class="layout-legal">
      <VCard>
        <VCardText>
          <h2 class="text-bree">{{ $gettext("LEGAL NOTICE") }}</h2>
        </VCardText>
        <VCardText>
          <CollapseInfomation :data="dataLegals" :infomation="true" />
        </VCardText>
      </VCard>
    </div>

    <FooterBlank />
  </div>
</template>

<style lang="scss">
@import "@/assets/styles/pages/register.scss";
.register {
  display: flex;
  flex-direction: column;
}
.layout-legal {
  max-width: 70%;
  margin: auto;
  margin-top: -72px;

  h2 {
    text-align: center;
    color: rgba(var(--v-theme-second-primary));
    font-weight: 500;
  }
}
.footer-blank {
  padding: 0 !important;
  align-content: end;

  &__container {
    margin-top: 30px !important;
    position: unset !important;
    bottom: unset !important;
    left: unset !important;
    transform: unset !important;
  }
}
</style>
